import { render, staticRenderFns } from "./PraesidiumCardQuestions.vue?vue&type=template&id=1f10ba54&"
import script from "./PraesidiumCardQuestions.vue?vue&type=script&lang=ts&"
export * from "./PraesidiumCardQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./PraesidiumCardQuestions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports